<template lang="pug">
    div.record

        div.recordMarker

            div
                // Avatar
                div.recordAvatar(:class="color")
                    v-icon(color="white") {{ iconName }}

            // Vertical line
            div.recordLine

        div.recordContent

            // Date
            div.d-flex.align-center
                div.recordDate  {{ item.createdAt | formattedDateAndTime }}
                div
                  div.recordType(v-if="item.note && item.note.noteType") {{ item.note.noteType }}

            // Title
            div.recordTitle {{ isTimer ?  timerTitle : title }}
                // Edit record
                span.recordEdit(v-if="item.type === 'note'" @click="() => setNote(item.note)")
                    v-icon(color="action") edit
                    span Edit

                // Delete record
                span.recordDelete(v-if="item.type === 'note'" @click="() => deleteNote(item.note.id)")
                    v-icon(color="action") delete
                    span Delete

            // Text
            div.recordText(v-if="!isTimer" v-html="text" @click="navigateToMeditation")
</template>

<script>
    import VueTypes from 'vue-types';
    import RecordService from './record.service.js';
    import dayjs from 'dayjs';
    import formattedDateAndTime from '~filters/FormattedDateAndTime';
    import { mapActions } from 'vuex';

    export default {
        filters: {
            formattedDateAndTime
        },
        props: {
            item: VueTypes.object.def({}),
            showShareButton: VueTypes.bool.def(false)
        },
        computed: {
            iconName() {
                return RecordService.getRecordIcon(this.item.type);
            },
            title() {
                return RecordService.getRecordTitle(this.item);
            },
            text() {
                return RecordService.getRecordText(this.item);
            },
            color() {
                return RecordService.getRecordAvatarColor(this.item.type);
            },

            isTimer() {
                return (
                    this.item?.session?.id ===
                    process.env.VUE_APP_TIMER_SESSION_ID
                );
            },

            timerTitle() {
                return `Timer ${
                    this.duration ? `${this.duration}min` : 'less than minute'
                }`;
            },

            duration() {
                if (!this.isTimer) return 0;
                const eventCreatedDate = dayjs(this.item?.createdAt);
                const time = this.item.session?.views?.find(view => {
                    return (
                        Math.abs(
                            eventCreatedDate.diff(dayjs(view.updatedAt))
                        ) <= 10000
                    );
                })?.time;
                return Math.ceil(time / 60);
            }
        },
        methods: {
            ...mapActions('notes', ['setNote', 'deleteNote']),
            navigateToMeditation() {
                if (this.item.type !== 'watch') return;

                this.$router.push({
                    name: 'dashboard.sessions.view',
                    params: { id: this.item.session.id }
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"
    .record
        display: flex
        max-width: 400px

    .recordMarker
        margin-right: 10px
        display: flex
        flex-direction: column
        align-items: center

    .recordAvatar
        display: flex
        align-items: center
        justify-content: center
        width: 40px
        height: 40px
        border-radius: 40px
        background: $theme.primary

    .recordType
      margin-left: 10px
      text-transform: capitalize
      padding: 1px 5px
      background-color: $theme.action
      border-radius: 2px
      display: inline-block

    .noteColor
        background-color: #395F4A

    .watchColor
        background-color: #4F586F

    .achievementColor
        background-color: #E1C2B8

    .recordLine
        margin: 5px
        height: 100%
        border-left: 1px solid rgba(255, 255, 255, 0.25);

    .recordContent
        padding: 10px 0 30px

    .recordDate
        font-size: 12px

    .recordTitle
        margin-top: 3px
        font-size: 15px
        font-weight: 700

    .recordEdit
    .recordDelete
        cursor: pointer
        transition: opacity 0.3s

        &:hover
            opacity: 0.7

        i
            font-size: 15px
            padding: 1px 2px 0 7px

        span
            font-size: 12px
            font-weight: 500
            text-decoration: underline;

    .recordText
        margin-top: 5px
        font-size: 12px

    >>> .recordLink
            color: $theme.white
            text-decoration: underline
            cursor: pointer
            transition: opacity 0.3s

            &:hover
                opacity: 0.7
</style>
